import { IconButton, IconButtonProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";

export const ToolbarIconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return (
    <IconButton
      ref={ref}
      size="sm"
      height="32px"
      minHeight="32px"
      minW="32px"
      borderRadius="6px"
      fontSize="18px"
      variant={props.variant || "ghost"}
      color="var(--white)"
      borderColor={props.variant === "outline" ? "var(--gray)" : undefined}
      bg={props.variant === "ghost" ? "transparent" : "var(--black)"}
      _hover={{ 
        bg: "var(--dark-gray)",
        borderColor: props.variant === "outline" ? "var(--accent)" : undefined 
      }}
      _active={{ bg: "rgba(255, 255, 255, 0.08)" }}
      _focusVisible={{ 
        outline: "2px solid var(--accent)", 
        outlineOffset: "2px",
        bg: "var(--dark-gray)" 
      }}
      _disabled={{ 
        opacity: 0.6, 
        cursor: "not-allowed",
        _hover: { bg: undefined }
      }}
      transition="all 0.2s"
      {...props}
    />
  );
});

ToolbarIconButton.displayName = "ToolbarIconButton";

